import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { createPulseIdentity, deletePulseIdentity, getPulseIdentity, queryPulseIdentities, updatePulseIdentity } from './generated/PulseIdentityClient/pulseIdentityHttpRequests';
import { PulseIdentityClientBase } from './PulseIdentityClientBase';
export class PulseIdentityClient extends HttpBaseClient(PulseIdentityClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createPulseIdentityImpl", createPulseIdentity);
    _defineProperty(this, "getPulseIdentityImpl", getPulseIdentity);
    _defineProperty(this, "updatePulseIdentityImpl", updatePulseIdentity);
    _defineProperty(this, "deletePulseIdentityImpl", deletePulseIdentity);
    _defineProperty(this, "queryPulseIdentitiesImpl", queryPulseIdentities);
  }
}
//# sourceMappingURL=PulseIdentityClientHttp.js.map